import React from 'react';
import cx from 'classnames';

import { Checkbox as AntCheckbox } from 'antd';
import { CheckboxProps } from 'antd/lib/checkbox';

import styles from './Checkbox.module.scss';

import { Group, ICheckboxGroupProps } from './CheckboxGroup';

export interface ICheckboxProps extends CheckboxProps {}
export type { ICheckboxGroupProps };

type TCheckbox = React.FC<ICheckboxProps> & {
  Group: typeof Group;
};

export const Checkbox: TCheckbox = ({ className, ...restProps }) => (
  <AntCheckbox className={cx(styles.Checkbox, className)} {...restProps} />
);

Checkbox.Group = Group;
